<template>
    <vx-sidebar
        hidden-background
        position-right
        v-model="localOpen"
        class="items-no-padding"
        :ref="categoryName"
        :key="categoryName"
    >
        <div style="height: 90vh">
            <div class="customizer-header mt-6 flex items-center justify-between px-6">
                <div>
                    <slot name="title">
                        <h4>{{ categoryName || 'Widgets' }}</h4>

                        <small>Drag widgets onto your dashboard</small>
                    </slot>
                </div>
                <vx-action-icon
                    icon="XIcon"
                    hover-color="danger"
                    @click.native.prevent.stop="localOpen = false"
                />
            </div>
            <vx-scroll-area>
                <div class="p-4 pb-6">
                    <widget-group-item
                        class="widget-group"
                        v-for="(categoryWidgets, name) in groups"
                        :key="name"
                        :widgets="categoryWidgets"
                        :category-name="name.capitalize()"
                        :depth="depth + 1"
                        @dragstart="onDragStart"
                        @dragend="onDragEnd"
                    />
                    <vs-divider v-if="localWidgets.length != 0 && groups.length != 0">
                        Widgets
                    </vs-divider>
                    <widget-preview
                        v-for="(widget, index) in localWidgets"
                        :key="index"
                        class="mb-3"
                        :widget="widget"
                        @subGroupOpened="$emit('subGroupOpened')"
                        @dragstart="onDragStart"
                        @dragend="onDragEnd"
                    />
                </div>
            </vx-scroll-area>
        </div>
    </vx-sidebar>
</template>

<script>
import WidgetGroupItem from './WidgetGroupItem.vue'
import WidgetPreview from './WidgetPreview.vue'

export default {
    name: 'widget-group',
    components: { WidgetPreview, WidgetGroupItem },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        widgets: {
            type: Array,
            default: () => []
        },
        depth: {
            type: Number,
            default: 0
        },
        categoryName: {
            type: String
        }
    },
    data() {
        return {}
    },
    computed: {
        localOpen: {
            get() {
                return this.open
            },
            set(v) {
                return this.$emit('update:open', v)
            }
        },
        groups() {
            var sorted = Object.entries(this.groupItems.groups)
                .defaultSort((g) => g[0])
                .reduce((groups, [group, widgets]) => ({ ...groups, [group]: widgets }), {})
            return sorted
        },
        localWidgets() {
            return this.groupItems.localWidgets.defaultSort((instance) => instance.name)
        },
        groupItems() {
            var results = {
                groups: {},
                localWidgets: []
            }
            this.widgets.forEach((widget) => {
                var category = widget.instance.category
                if (!category) {
                    results.localWidgets.push(widget)
                    return
                }
                var categoryPath = category.split('/')
                var categoryName = categoryPath[this.depth]
                if (!categoryName) {
                    results.localWidgets.push(widget)
                    return
                }
                if (!results.groups[categoryName]) {
                    results.groups[categoryName] = []
                }
                results.groups[categoryName].push(widget)
            })

            return results
        }
    },
    methods: {
        onDragStart(e) {
            this.localOpen = false
            this.$emit('dragstart', e)
        },
        onDragEnd(e) {
            this.localOpen = true
            this.$emit('dragend', e)
        }
    }
}
</script>

<style lang="scss" scoped></style>
